import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import { FaDownload, FaEye, FaTimes } from 'react-icons/fa';
import * as API from "../Endpoints/Endpoints";

function ViewStartupBot() {
  const [bot, setChatbots] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewOpen, setViewOpen] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const modalRef = useRef(null);

  useEffect(() => {
    const fetchbot = async () => {
      try {
        const response = await axios.get(API.GET_STARTUP_API);
        setChatbots(response.data);
      } catch (error) {
        console.error('Error fetching startups:', error);
        toast.error('Failed to fetch startups');
      }
    };
    fetchbot();
  }, []);

  useEffect(() => {
    if (viewOpen && modalRef.current) {
      // ensure modal scroll at top when opened
      setTimeout(() => {
        try {
          modalRef.current.scrollTop = 0;
        } catch (e) { /* ignore */ }
      }, 0);
    }
  }, [viewOpen]);

  const filteredBots = bot.filter((item) => {
    const q = (searchQuery || '').toLowerCase();
    return (
      item.useremail?.toLowerCase().includes(q) ||
      item.organizationname?.toLowerCase().includes(q) ||
      item.startuptitle?.toLowerCase().includes(q) ||
      item.startupdescription?.toLowerCase().includes(q) ||
      item.startupproblem?.toLowerCase().includes(q) ||
      item.startupsolution?.toLowerCase().includes(q) ||
      item.startuparchitect?.toLowerCase().includes(q) ||
      item.startuptool?.toLowerCase().includes(q) ||
      item.startupschedule?.toLowerCase().includes(q) ||
      item.startupcanvamodel?.toLowerCase().includes(q) ||
      item.startupmarketarea?.toLowerCase().includes(q) ||
      item.startuprevenuemodel?.toLowerCase().includes(q) ||
      item.startupreport?.toLowerCase().includes(q) ||
      item.startupimpact?.toLowerCase().includes(q) ||
      item.startuptechnologies?.toLowerCase().includes(q) ||
      item.startupsteam?.toLowerCase().includes(q) ||
      item.startupvision?.toLowerCase().includes(q)
    );
  });

  // open a view modal and load the selected startup (refetch to ensure fresh copy)
  const handleView = async (item) => {
    try {
      setViewLoading(true);
      setViewOpen(true);
      setSelected(null);

      const res = await axios.get(API.GET_STARTUP_API);
      const rec = res.data.find((r) => r.startupid === item.startupid);
      if (!rec) {
        toast.error('Record not found');
        setViewOpen(false);
        return;
      }
      setSelected(rec);
    } catch (err) {
      console.error(err);
      toast.error('Failed to load details');
      setViewOpen(false);
    } finally {
      setViewLoading(false);
    }
  };

  const handleImport = (item) => {
    const doc = new jsPDF();
    let yPosition = 20;
    const lineHeight = 10;
    const maxWidth = 180;
    const pageHeight = doc.internal.pageSize.height;

    const addText = (text, x, y) => {
      const safe = String(text ?? '');
      const splitText = doc.splitTextToSize(safe, maxWidth);
      doc.text(splitText, x, y);
      return splitText.length * lineHeight;
    };

    const checkAndAddPage = (currentYPosition) => {
      if (currentYPosition + lineHeight > pageHeight) {
        doc.addPage();
        return 20;
      }
      return currentYPosition;
    };

    const addHeading = (heading, x, y) => {
      doc.setFont('helvetica', 'bold');
      y += addText(heading, x, y);
      doc.setFont('helvetica', 'normal');
      return y;
    };

    yPosition = addHeading(`Organization name:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.organizationname, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`User email:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.useremail, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Title:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startuptitle, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Description:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupdescription, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Problems:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupproblem, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Solution:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupsolution, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Technology Architect:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startuparchitect, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Technology Tool:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startuptool, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Schedule:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupschedule, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Business Canva:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupcanvamodel, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Market Area:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupmarketarea, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Revenue Model:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startuprevenuemodel, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Valuation Report:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupreport, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Impact:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupimpact, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Recommended Technologies:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startuptechnologies, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`STEAM Theory:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupsteam, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Vision Mission:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.startupvision, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    doc.save(`${(item.startuptitle || 'startup')}.pdf`);
  };

  return (
    <div className="container mx-auto px-4 mt-10">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Startup References</h1>
        <input
          type="text"
          placeholder="Search..."
          className="px-4 py-2 border rounded-md"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border-gray-300 shadow-md rounded-md table-fixed">
          <colgroup>
            <col style={{ width: '6%' }} />
            <col style={{ width: '4%' }} />
            <col />
          </colgroup>

          <thead className="bg-gray-800 text-white">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold">Actions</th>
              <th className="px-4 py-3 text-left text-sm font-semibold">Sr No</th>
              <th className="px-4 py-3 text-left text-sm font-semibold">Title</th>
            </tr>
          </thead>

          <tbody>
            {filteredBots.map((item, index) => (
              <tr key={item.startupid || index} className="border-b align-top">
                <td className="px-4 py-3 whitespace-normal">
                  <div className="flex items-center gap-2">
                    <button
                      className="text-indigo-600 hover:underline flex items-center gap-1"
                      onClick={() => handleView(item)}
                      title="View"
                    >
                      <FaEye />
                    </button>
                    <button
                      className="text-blue-500 hover:underline flex items-center gap-1"
                      onClick={() => handleImport(item)}
                      title="Export as PDF"
                    >
                      <FaDownload />
                    </button>
                    {/* Uncomment and implement if you have edit/delete components
                        <EdituserStartup startupid={item.startupid} refreshList={refreshList} />
                        <DeleteuserStartup startupid={item.startupid} refreshList={refreshList} />
                    */}
                  </div>
                </td>

                <td className="px-4 py-3 whitespace-normal text-sm">{index + 1}</td>

                <td className="px-4 py-3 whitespace-normal text-sm break-words max-w-[420px]">
                  {item.startuptitle || 'Untitled'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* VIEW MODAL */}
      {viewOpen && (
        <div className="fixed inset-0 z-50 flex items-start sm:items-center justify-center bg-black/50 p-4">
          <div
            ref={modalRef}
            className="bg-white w-full max-w-5xl rounded-2xl shadow-xl p-6 relative overflow-y-auto max-h-[90vh]"
          >
            <button
              className="absolute top-4 right-4 text-gray-600 hover:text-black"
              onClick={() => { setViewOpen(false); setSelected(null); }}
              aria-label="Close"
            >
              <FaTimes />
            </button>

            {viewLoading ? (
              <div className="py-20 text-center">Loading...</div>
            ) : selected ? (
              <>
                <div id="pdf-like" className="border rounded-xl p-6 bg-white">
                  <div className="mb-1 text-2xl font-semibold break-words">
                    {selected.startuptitle || 'Untitled Startup'}
                  </div>
                  <div className="text-sm text-gray-600 mb-4">
                    {selected.useremail ? `By ${selected.useremail}` : ''} {selected.organizationname ? `• ${selected.organizationname}` : ''}
                  </div>

                  <PdfSection title="Description" text={selected.startupdescription} />
                  <PdfSection title="Problems" text={selected.startupproblem} />
                  <PdfSection title="Solution" text={selected.startupsolution} />
                  <PdfSection title="Technology Architect" text={selected.startuparchitect} />
                  <PdfSection title="Technology Tool" text={selected.startuptool} />
                  <PdfSection title="Schedule" text={selected.startupschedule} />
                  <PdfSection title="Business Canva" text={selected.startupcanvamodel} />
                  <PdfSection title="Market Area" text={selected.startupmarketarea} />
                  <PdfSection title="Revenue Model" text={selected.startuprevenuemodel} />
                  <PdfSection title="Valuation Report" text={selected.startupreport} />
                  <PdfSection title="Impact" text={selected.startupimpact} />
                  <PdfSection title="Recommended Technologies" text={selected.startuptechnologies} />
                  <PdfSection title="STEAM Theory" text={selected.startupsteam} />
                  <PdfSection title="Vision Mission" text={selected.startupvision} />
                </div>

                <div className="mt-6 flex justify-end">
                  <button
                    className="px-6 py-2 bg-gray-600 text-white rounded-lg shadow hover:bg-gray-700"
                    onClick={() => { setViewOpen(false); setSelected(null); }}
                  >
                    Back
                  </button>
                </div>
              </>
            ) : (
              <div className="py-20 text-center text-red-600">No record found.</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function PdfSection({ title, text }) {
  if (!text) return null;
  return (
    <div className="mt-5">
      <h3 className="text-lg font-semibold border-b border-gray-200 pb-1">{title}</h3>
      <div className="mt-2 whitespace-pre-wrap leading-relaxed text-gray-800 break-words">
        {text}
      </div>
    </div>
  );
}

export default ViewStartupBot;
